import React from 'react';
import UpdateIntervals from './components/UpdateIntervals';
import IntervalSetupList from '../../shared/ui/IntervalSetupList';
import { ActiveToggleProvider } from './providers/activeToggleProvider';
import ActiveToggle from './components/ActiveToggle';
import Period from './components/Period';
import {
  DisabledIntervalsProvider,
  useDisabledIntervals,
} from './providers/disabledIntervalsProvider';
import { useSyncClassicTimes } from './hooks/syncTimes';

export { useSyncClassicTimes };

export const ClassicSetupIntervals = ({
  observableNames,
  intervalsName,
  fields,
  intervalActiveToggleConfig,
  renderIntervalSettings,
  isIntervalDisabled,
}) => {
  return (
    <UpdateIntervals
      observableNames={observableNames}
      intervalsName={intervalsName}
    >
      <ActiveToggleProvider config={intervalActiveToggleConfig}>
        <DisabledIntervalsProvider intervalsName={intervalsName}>
          <IntervalList
            fields={fields}
            renderIntervalSettings={renderIntervalSettings}
            isIntervalDisabled={isIntervalDisabled}
          />
        </DisabledIntervalsProvider>
      </ActiveToggleProvider>
    </UpdateIntervals>
  );
};

function IntervalList({ fields, renderIntervalSettings, isIntervalDisabled }) {
  const disabledIntervals = useDisabledIntervals();

  return (
    <IntervalSetupList
      intervalFields={fields}
      renderRowStart={ActiveToggle}
      renderRowMiddle={Period}
      renderRowEnd={renderIntervalSettings}
      rowType={IntervalSetupList.rowTypes.classic}
      isRowBodyDisabled={({ field }) => disabledIntervals.has(field.intervalId)}
      isRowDisabled={isIntervalDisabled}
    />
  );
}
